import * as yup from 'yup';

export const sendOfferFormSchema = yup.object().shape({
  campaign: yup.string().required().nullable().default(null),
  loyaltyOffer: yup.string().required().nullable().default(null),
  ignoreDistributionRules: yup.boolean().default(false),
  ignoreRedistributionMode: yup.boolean().default(false),
  ignoreBlackoutPeriod: yup.boolean().default(false),
});
